import React, { useMemo } from 'react';
import { Progress as AntProgress, Typography } from 'antd';
import { Flex } from '../../../../ui';
import styled from 'styled-components';

export const Progress = ({ currentStep = 0, steps = 1, step, isAdmin, ...props }) => {
  step = step - 1;

  // Mark identical siblings to only show the last step
  const [groupedSteps, displayedSteps] = useMemo(() => {
    // these get updated by the .map() to avoid another iteration
    let displayCount = 0;
    const skippedSteps = [];

    const groupedSteps = steps.map((step, index) => {
      if (isAdmin) {
        const hiddenCount = index - displayCount;
        displayCount++;
        return [index, index - hiddenCount, true];
      } else {
        if (skippedSteps.includes(index)) {
          displayCount++;
          return [index, index - 1, null]
        }

        const hiddenCount = index - displayCount;

        if (step !== steps[index + 1]) {
          displayCount++;
          return [index, index - hiddenCount, true];
        }

        let statusIndex = index;
        const indexes = [statusIndex];
        while (step === steps[statusIndex + 1] && statusIndex < steps.length) {
          statusIndex++;
          indexes.push(statusIndex);
          skippedSteps.push(index + 1);
        }

        return [
          // The index used for the status in the panel (last of the group)
          indexes,
          // The index used for the display in the panel (first of the group)
          index - hiddenCount,
          // Do not display the step
          false
        ];
      }
    });

    return [groupedSteps, displayCount];
  }, [steps]);

  return (
    <StyledRow>
      <AntProgress
        style={{ margin: 0, width: '100%' }}
        showInfo={false}
        {...props}
        format={() => `${currentStep}/${steps}`}
        percent={Math.floor((currentStep / displayedSteps) * 100)}
      />

      <Text>
        {currentStep}/{displayedSteps}
      </Text>
    </StyledRow>
  );
};

const StyledRow = styled(Flex)`
  gap: 18px;
`;

const Text = styled(Typography.Text)`
  flex-shrink: 0;
  width: auto;
  line-height: 24px;
  max-height: 24px;
  overflow: hidden;
`;
